// extracted by mini-css-extract-plugin
module.exports = {"post_list":"index-module--post_list--1PWQC","post_title":"index-module--post_title--3yCPE","post_date":"index-module--post_date--3mEdN"};